import { render, staticRenderFns } from "./CardFooter.vue?vue&type=template&id=81ad7006&"
import script from "./CardFooter.vue?vue&type=script&lang=js&"
export * from "./CardFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81ad7006')) {
      api.createRecord('81ad7006', component.options)
    } else {
      api.reload('81ad7006', component.options)
    }
    module.hot.accept("./CardFooter.vue?vue&type=template&id=81ad7006&", function () {
      api.rerender('81ad7006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardListBuilder/CardFooter.vue"
export default component.exports